import React, { useState, useEffect } from "react";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { toast } from "react-toastify";

const VendorSequenceModal = ({
  show,
  handleClose,
  vendor,
  vendorData,
  data,
  onSave,
}) => {
  const [sequences, setSequences] = useState([
    { toggle: false, inputs: ["", "", ""] },
    { toggle: false, inputs: ["", "", ""] },
    { toggle: false, inputs: ["", "", ""] },
  ]);

  const [isActive, setIsActive] = useState(true);
  const [inputs, setInputs] = useState(["", "", ""]);

  useEffect(() => {
    if (show && vendor) {
      const currentStatus = vendor?.authStatus?.toLowerCase();

      if (currentStatus === "active") {
        setIsActive(true);
      } else if (
        currentStatus === "de-active" ||
        currentStatus === "inactive" ||
        currentStatus === "in-active"
      ) {
        setIsActive(false);
      }

      setInputs([vendor.seq1 || "", vendor.seq2 || "", vendor.seq3 || ""]);
    }
  }, [show, vendor]);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  const handleInputChange = (index, value) => {
    const updated = [...inputs];
    updated[index] = value;
    setInputs(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const username = sessionStorage.getItem("username") || "admin1";
    const vendorId = vendor?.vendorId;

    if (!vendorId) {
      toast.error("Vendor not found!");
      return;
    }

    const status = isActive ? "1" : "2"; // 1 = Active, 2 = Deactive

    if (!inputs[0] || !inputs[1] || !inputs[2]) {
      toast.error(
        "Please fill in all three sequence values (seq1, seq2, seq3)."
      );
      return;
    }

    const requestBody = {
      username,
      vendorId,
      status,
      seq1: inputs[0],
      seq2: inputs[1],
      seq3: inputs[2],
    };

    console.log("Final payload", requestBody);

    try {
      const response = await axiosPostApi(
        apiList.AUTH_VENDOR_DATA,
        requestBody
      );

      const apiSuccess =
        response?.status === 200 &&
        response?.data?.status === true &&
        response?.data?.respCode === "00";

      if (apiSuccess) {
        toast.success("Vendor updated successfully!");
        setInputs(["", "", ""]);
        setIsActive(true);
        onSave();
        handleClose();
      } else {
        toast.error(response?.data?.message || "Failed to update vendor.");
      }
    } catch (error) {
      console.error("Authorization API error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "640px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Sequence</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="flex items-center justify-between mt-4 px-4">
                  <div className="ml-2 text-sm text-gray-700">
                    {isActive ? "ACTIVE" : "DE-ACTIVE"}
                  </div>
                  <div
                    className="w-[56px] h-[28px] rounded-full border-2 flex items-center px-[3px] transition-all duration-300 cursor-pointer"
                    onClick={handleToggle}
                    style={{
                      backgroundColor: isActive ? "#00b6ce" : "#ffffff",
                      borderColor: "#00b6ce",
                      justifyContent: isActive ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      className="rounded-full transition-all duration-300"
                      style={{
                        width: "18px",
                        height: "18px",
                        backgroundColor: "#ffffff",
                        border: isActive ? "none" : "2px solid #00b6ce",
                      }}
                    ></div>
                  </div>

                  {inputs.map((value, index) => (
                    <input
                      key={index}
                      type="text"
                      placeholder={`Seq ${index + 1}`}
                      value={value}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      className="w-16 h-10 text-center text-sm bg-gray-100 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
                    />
                  ))}
                </div>

                <div className="flex justify-end gap-4 px-4 mt-6 border-t pt-4">
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorSequenceModal;
